// F-28: the newsletter form answers every sign-up in place: received, not sure, or not valid.
// F-28a: under single opt-in the not-sure notice promises a subscription, not a confirmation link.
const newsletterKey='elmsett.newsletter.draft',newsletterSent='elmsett.newsletter.sent';
document.querySelectorAll('.es-newsletter-form').forEach(form=>{
 const input=form.querySelector('input[type="email"]');
 if(!input)return;
 const store={get:k=>{try{return sessionStorage.getItem(k)}catch{return null}},set:(k,v)=>{try{sessionStorage.setItem(k,v)}catch{}},del:k=>{try{sessionStorage.removeItem(k)}catch{}}};
 const result=form.querySelector('[data-newsletter-result]'),notice=form.querySelector('[data-newsletter-notice]'),fields=form.querySelector('[data-newsletter-fields]'),error=form.querySelector('.es-newsletter-error');
 // Shopify may put its verification page between the submit and the answer; that page carries this footer too.
 const verifying=location.pathname.startsWith('/challenge');
 let sent=null;try{sent=JSON.parse(store.get(newsletterSent)||'null')}catch{}
 const fresh=!!sent&&typeof sent.email==='string'&&Date.now()-sent.at<600000;
 // A reloaded page opens at the top and a screen reader stays silent about text that was already there, so bring the answer into view and hand it the focus. No smooth scrolling.
 const reveal=(box,target)=>{
  const settle=()=>box.scrollIntoView({block:'center',behavior:'instant'});
  target.focus({preventScroll:true});settle();
  if(document.readyState==='complete')return;
  let moved=false;const mark=()=>{moved=true};
  ['wheel','touchstart','keydown','pointerdown'].forEach(type=>addEventListener(type,mark,{once:true,passive:true}));
  addEventListener('load',()=>{if(!moved)settle()},{once:true});
 };
 const unsure=(email,atLoad)=>{
  if(!notice)return;
  const title=document.createElement('h3'),body=document.createElement('p');
  title.className='es-newsletter-notice__title';title.tabIndex=-1;title.textContent="We couldn't confirm that sign-up";
  body.className='es-newsletter-notice__body';
  const outcome=notice.dataset.newsletterDoubleOptIn==='false'?" is new to us, you're now subscribed.":' is new to us, a confirmation link is on its way.';
  if(email){const address=document.createElement('strong');address.textContent=email;body.append('If ',address,outcome);}
  else body.append('If your email'+outcome);
  body.append(" Already subscribed? You're all set. Otherwise, please try again.");
  // At load nothing announces text that is already there, so the heading takes the focus and the live region stays quiet. Later the live region speaks for itself and the shopper is left where they are.
  if(atLoad){notice.setAttribute('aria-live','off');notice.replaceChildren(title,body);reveal(notice,title);return;}
  // Only a shopper who still has the field and Subscribe fully on screen sees it move: keep the whole form in view for them, and never fetch anyone back from elsewhere on the page.
  const at=(form.querySelector('.es-newsletter-controls')||form).getBoundingClientRect(),watching=at.height>0&&at.top>=0&&at.bottom<=innerHeight;
  notice.replaceChildren(title,body);
  if(watching)form.scrollIntoView({block:'nearest',behavior:'instant'});
 };
 if(result){
  store.del(newsletterKey);store.del(newsletterSent);
  const address=form.querySelector('[data-newsletter-address]'),again=form.querySelector('[data-newsletter-again]');
  if(fresh&&sent.email&&address){address.textContent=sent.email;form.querySelector('[data-newsletter-addressed]').hidden=false;form.querySelector('[data-newsletter-generic]').hidden=true;}
  if(again&&fields){again.hidden=false;again.addEventListener('click',()=>{result.hidden=true;fields.hidden=false;if(fresh&&sent.email)input.value=sent.email;input.focus();input.select();});}
  reveal(result,result.querySelector('[tabindex="-1"]')||result);
 }else if(error){
  store.del(newsletterSent);reveal(fields||form,input);
 }else if(fresh&&!verifying){
  store.del(newsletterSent);if(!input.value)input.value=sent.email;unsure(sent.email,true);
 }else if(!input.value)input.value=store.get(newsletterKey)||'';
 let waiting=0;
 form.addEventListener('submit',()=>{
  // Whatever answer is showing belongs to an earlier sign-up, so it steps aside for this one, and the field stops describing itself by it.
  const address=input.value.trim();
  if(notice){notice.replaceChildren();notice.removeAttribute('aria-live');}
  if(result)result.hidden=true;
  if(error){error.hidden=true;input.removeAttribute('aria-invalid');input.setAttribute('aria-describedby',(input.getAttribute('aria-describedby')||'').split(/\s+/).filter(id=>id&&id!==error.id).join(' '));}
  store.set(newsletterSent,JSON.stringify({email:address,at:Date.now()}));
  window.clearTimeout(waiting);
  waiting=window.setTimeout(()=>{
   if(!document.contains(form)||(notice&&notice.childElementCount))return;
   store.del(newsletterSent);unsure(address,false);
  },15000);
 });
 input.addEventListener('input',()=>store.set(newsletterKey,input.value));
});

// Keep the native Judge.me photo gallery usable without a pointer.
(() => {
 let active=null,opener=null;
 const visible=e=>!!e?.isConnected&&e.getClientRects().length>0&&getComputedStyle(e).visibility!=='hidden';
 const find=()=>[...document.querySelectorAll('.jdgm-modal__content[role="dialog"][aria-label="Review Media Gallery"]')].find(visible);
 document.addEventListener('click',event=>{
  const trigger=event.target.closest('[aria-label="View review image"]');
  if(trigger)opener=trigger;
 },true);
 const sync=()=>{
  const dialog=find();
  if(dialog&&dialog!==active){active=dialog;dialog.querySelector('button[aria-label="Close"]')?.focus({preventScroll:true});}
  else if(!dialog&&active){active=null;if(opener?.isConnected)opener.focus({preventScroll:true});opener=null;}
 };
 new MutationObserver(sync).observe(document.documentElement,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class','hidden','aria-hidden']});
 document.addEventListener('keydown',event=>{
  const trigger=event.target.closest('[role="button"][aria-label="View review image"]');
  if(!active&&trigger&&!trigger.matches('button,a')&&(event.key==='Enter'||event.key===' ')){
   event.preventDefault();event.stopPropagation();opener=trigger;trigger.click();return;
  }
  if(!active||!visible(active))return;
  if(event.key==='Escape'){event.preventDefault();event.stopPropagation();active.querySelector('button[aria-label="Close"]')?.click();return;}
  if(event.key!=='Tab')return;
  const items=[...active.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter(visible);
  if(!items.length)return;
  const current=document.activeElement,first=items[0],last=items[items.length-1];
  if(!active.contains(current)||(event.shiftKey&&current===first)||(!event.shiftKey&&current===last)){
   event.preventDefault();(event.shiftKey?last:first).focus();
  }
 },true);
 sync();
})();
